import React from 'react';
import TaxInvoiceHeader from './TaxInvoiceHeader';
import TaxInvoiceContent from './TaxInvoiceContent';

const TaxInvoicePage = () => (
    <>
        <TaxInvoiceHeader />
        <TaxInvoiceContent />
    </>
);

export default TaxInvoicePage;
